<template>
	<div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-6 mb-4">
                    <div class="card border-start-success">
                        <div class="card-body px-3 py-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div class="me-2">
                                    <div class="text-success widget-title-card">{{ formatNum(totalPegawaiByJabatan, 0) }}</div>
                                    <div class="card-text">Total Pegawai</div>
                                </div>
                                <div class="d-flex icon-circle text-success text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="fa fa-users"></i></div>
                            </div>
                        </div>
                    </div>		
                    <Loader v-if="loading.table" />			
                </div>

                <div class="col-md-3 mb-4">
                    <div class="card border-start-warning">
                        <div class="card-body px-3 py-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div class="me-2">
                                    <div class="text-warning widget-title-card">{{ formatNum(lakilaki, 0) }}</div>
                                    <div class="card-text">Laki-laki</div>
                                </div>
                                <div class="d-flex icon-circle text-warning text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="fa fa-male"></i></div>
                            </div>
                        </div>
                    </div>		
                    <Loader v-if="loading.table" />			
                </div>

                <div class="col-md-3 mb-4">
                    <div class="card border-start-danger">
                        <div class="card-body px-3 py-2">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <div class="me-2">
                                    <div class="text-danger widget-title-card">{{ formatNum(perempuan, 0) }}</div>
                                    <div class="card-text">Perempuan</div>
                                </div>
                                <div class="d-flex icon-circle text-danger text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="fa fa-female"></i></div>
                            </div>
                        </div>
                    </div>		
                    <Loader v-if="loading.table" />			
                </div>

                <div class="col-md-3 mb-4" v-if="false">
                    <el-card shadow="hover">
                        <div slot="header" class="px-1">
                            <h6 class="text-center m-0">Pegawai By Jenis Kelamin</h6>
                        </div>
                      
                        <PieChart class="mt-0" :data="this.chartdatabygender" :url="''" style="width:100%;" :showlegend="false"/>
                    </el-card>
                    <Loader v-if="loading.table" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-4">
                    <el-card shadow="hover">
                        <div slot="header">
                            <h5 class="text-center m-0 px-2">Pegawai By Jabatan</h5>
                        </div>
                        <div>
                            <table class="table-g" style="width:100%;">
                                <thead>
                                    <tr class="border-bottom">
                                        <th class="pb-2">Jabatan</th>
                                        <th class="text-center">Jumlah</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in reportdata?.data?.jabatan" :key="item.Jabatan">
                                        <td class="py-2">{{ item.Jabatan }}</td>
                                        <td class="py-2 text-center">{{ formatNum(item.TotalPegawai, 0) }}</td>
                                    </tr>
                                    <tr class="border-top">
                                        <td class="pt-2 fw-bold">Total</td>
                                        <td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-card>
                    <Loader v-if="loading.table" />
                </div>

                <div class="col-md-6 mb-4">
                    <el-card shadow="hover">
                        <div slot="header">
                            <h5 class="text-center m-0 px-2">Pegawai By Jenjang Pendidikan</h5>
                        </div>
                        <div>
                            <table class="table-g" style="width:100%;">
                                <thead>
                                    <tr class="border-bottom">
                                        <th class="pb-2">Jenjang Pendidikan</th>
                                        <th class="text-center">Jumlah</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in reportdata?.data?.jenjang_pendidikan" :key="item.Jenjang">
                                        <td class="py-2">{{ item.Jenjang }}</td>
                                        <td class="py-2 text-center">{{ formatNum(item.TotalPegawai,0) }}</td>
                                    </tr>
                                    <tr class="border-top">
                                        <td class="py-1 fw-bold">Total</td>
                                        <td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-card>
                    <Loader v-if="loading.table" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-4">          
                    <el-card shadow="hover">
                        <div slot="header">
                            <h5 class="text-center m-0 px-2">Pegawai By Vendor</h5>
                        </div>
                        <div>
                            <table class="table-g" style="width:100%;">
                                <thead>
                                    <tr class="border-bottom">
                                        <th class="pb-2">Vendor</th>
                                        <th class="text-center">Jumlah</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in reportdata?.data?.vendor" :key="item.VendorName">
                                        <td class="py-2">{{ item.VendorName }}</td>
                                        <td class="text-center">{{ formatNum(item.TotalPegawai,0) }}</td>
                                    </tr>
                                    <tr class="border-top">
                                        <td class="pt-2 fw-bold">Total</td>
                                        <td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-card>
                    <Loader v-if="loading.table" />
                </div>

            </div>

        </div>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import { Rainbow, FuelColor, AppColors, Penanggalan, AxiosWithJar, Config} from '@/utility.js'
import PieChart from '@/components/chart/Doughnut.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Loader from '@/components/loader/Loader2.vue'
//import Footer from '@/views/Footer.vue'

export default{
	extends: Cafe,
	components:{
        PieChart,
        Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//Footer            
	},
    props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
        unitids: {
            type: Array,
            default() {
                return [];
            }
            //default: [],
            //required: false,
        },
        year: {
            type: Number,
            default: Penanggalan().tahun,
            //required: false,
        },
        month: {
            type: Number,
            default: Penanggalan().bulan,
            //required: false,
        },
    },
    data() {
		return {
            //unitids : [],
            reportdata: [],
            chartdatabygender: [],
            lakilaki: 0,
            perempuan: 0,
            loading: {
                table: false,
            },
		}
	},
    watch: {
        unitids() {
            this.getPegawaiOverview(); 
            //get data
            //console.log('unitids: ' + this.unitids);
        },
    },
    mounted()
	{
		//this.getPegawaiOverview();
    },
    computed: {
		totalPegawaiByJabatan() {
			return this.reportdata?.data?.jabatan?.reduce((sum, item) => sum + parseFloat(item.TotalPegawai), 0);
		},
        totalPegawaiByVendor() {
			return this.reportdata?.data?.vendor?.reduce((sum, item) => sum + parseFloat(item.TotalPegawai), 0);
		},
        totalPegawaiByJenjang() {
			return this.reportdata?.data?.jenjang_pendidikan?.reduce((sum, item) => sum + parseFloat(item.TotalPegawai), 0);
		},
	},
    methods:{
        async getPegawaiOverview() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/hrga/pegawaigroupoverview?'

			//this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&unitgroup='+this.unitids
			this.urlRequestParams+='&plant='+this.plant

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;

                    //console.log('this.reportdata' + JSON.stringify(this.reportdata["data"]))
                    this.setPiechartData(this.reportdata?.data?.jenis_kelamin);
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        setPiechartData(data) {
			let item = data //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //if((item[row].JenisKelamin).toLowerCase() == 'L'.toLowerCase() || (item[row].JenisKelamin).toLowerCase() == 'Laki-laki'.toLowerCase() || (item[row].JenisKelamin).toLowerCase() == 'Pria'.toLowerCase())
                const gender = (item[row].JenisKelamin).toLowerCase();
                if (['l', 'laki-laki', 'laki laki', 'lakilaki', 'pria'].includes(gender))
                    this.lakilaki += item[row].TotalPegawai
                else
                    this.perempuan += item[row].TotalPegawai

                //add color
                warna[item[row].JenisKelamin] = AppColors[idx];// AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].JenisKelamin, 
                    amount: item[row].TotalPegawai,
                };

                value.push(main);
                idx++;
            }

            this.chartdatabygender = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },
	}
}

</script>

<style>

.border-start-primary {
	border-left: 5px solid #007BFF !important; /** card-raised border-start border-green border-5 */
}

.border-start-success {
	border-left: 5px solid #67C23A !important; /** card-raised border-start border-green border-5 */
}

.border-start-warning {
	border-left: 5px solid #E6A23C !important; /** card-raised border-start border-green border-5 */
}

.border-start-danger {
	border-left: 5px solid #F56C6C !important; /** card-raised border-start border-green border-5 */
}

.widget-icon {
	opacity: .3;
}
</style>